// src/com/login/ForgotPassword.js
import React, {useState} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import UndoIcon from '@mui/icons-material/Undo';
import { Button, TextField } from '@mui/material';
import { useMutation } from '@apollo/client';
import { AppStyle } from '../../value/AppConst';
import { useAlertSetter } from '../../api/app-hook';
import { START_RESET_USER_INFO_PASSWORD_USING_EMAIL } from '../user_info/UserInfoGql';
import IsValid from '../../value/IsValid';

const XContainer = styled(Box)({
    display: 'flex', // flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh', boxSizing: 'border-box', // backgroundColor: 'yellow',
});

const ContentBox = styled(Box)({
    minWidth: 500, width: '60%', maxWidth: 840,
    display: 'inline-flex',
    flexDirection: 'column',
});

const MainTitle = styled(Box)({
    padding:10, fontWeight:'bold', backgroundColor: AppStyle.HeaderBackgroundColor, color:'white',
    textAlign:'center', borderTopLeftRadius:20, borderTopRightRadius:20,
    fontSize: '1.2em',
});

const ContentBody = styled(Box)({
    padding:20,
    border: '1px solid ' + AppStyle.HeaderBackgroundColor,
    borderBottomLeftRadius:20, borderBottomRightRadius:20,
});

const CardsBox = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const CardItem = styled(Box)({
    border: '1px solid ' + AppStyle.HeaderBackgroundColor,
    borderRadius: 10,
    flexGrow: 1,
    height: 40, display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 1,
});

const ResponseMessageBox = styled(Box)({
    marginTop: 20,
    padding: 10,
    borderRadius: 10,
    backgroundColor: '#f0f0f0',
    color: 'green',
    fontWeight: 'bold',
    textAlign: 'center',
});

/**
 * 암호를 잊은 경우 메일을 사용하여 재설정 링크를 받는 컴포넌트.
 * 암호가 대소문자가 섞여 있는 경우는 대소문자까지 정확히 입력해야 한다.
 * @param {*} param0 
 * @returns 
 */
export default function ForgotPassword({
    onClose,
}) {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState(null);
    const addAlert = useAlertSetter();
    const [startResetPassword, resReset] = useMutation( START_RESET_USER_INFO_PASSWORD_USING_EMAIL, {
        onCompleted: (data, option) => onCompleteStartReset(data, option),
        onError: (error) => {addAlert({title:"암호 재설정 링크 발송 오류", message:[error.message]})},
    } );

    const onCompleteStartReset = (data, option) => {
        if(data.userInfoStartResetPasswordUsingEmail.ok) {
            setMessage('암호 재설정 링크를 메일로 발송하였습니다. 메일을 확인하여 주십시오. (메일이 도착하지 않는 경우 스팸메일함도 확인하여 주십시오.)');
        }
        else {
            setMessage('암호 재설정 링크 발송에 실패하였습니다: ' + data.userInfoStartResetPasswordUsingEmail.message);
        }
    };

    const onChangeEmail = (e) => {
        setEmail(e.target.value);
    };

    const onClickSubmit = () => {
        // 메일 발송 요청.
        const param = { email: email.trim() };
        startResetPassword( { variables: { userInfo: param } } );
    };

    return(
        <XContainer>
            <ContentBox>
                <MainTitle>메일을 사용한 암호 재설정</MainTitle>
                <ContentBody>
                    <p>
                        암호 (혹은 아이디)를 잊어버린 경우 메일을 사용하여 재설정할 수 있습니다.
                    </p>
                    <p>
                        단, 현재 사용자 정보에 이메일 주소가 등록되어 있어야 하며, 등록된 메일주소를 정확히 알고 있어야 합니다.
                        <br/>
                        만일 이메일 주소를 대소문자를 섞어서 등록한 경우, 대소문자까지 정확히 입력해야 하는데, 그 이유는 시스템에서 이메일 주소를 암호화하여 저장하기 때문입니다. 다만, 이메일 주소가 전부 소문자 또는 전부 대문자로 저장되어 있는 경우에는 문제없이 진행됩니다.
                    </p>
                    <Box style={{textAlign:'center', marginTop:20, marginBottom:30}}>
                        <strong style={{marginBottom: 15, display: 'block', fontSize:'1.1rem'}}>
                            진행절차</strong>
                        <CardsBox>
                            <CardItem>메일주소 입력</CardItem><PlayArrowIcon />
                            <CardItem>메일 수신</CardItem><PlayArrowIcon />
                            <CardItem>암호변경 링크 클릭</CardItem><PlayArrowIcon />
                            <CardItem>새 암호 설정(20분 기한)</CardItem><PlayArrowIcon />
                            <CardItem>로그인</CardItem>
                        </CardsBox>
                    </Box>
                    <form>
                        <TextField
                            label='이메일 주소'
                            value={email}
                            onChange={onChangeEmail}
                            variant='outlined'
                            fullWidth
                        />
                        <Box style={{padding:10, textAlign:'center'}}>
                            <Button variant='contained' color='primary'
                                onClick={onClickSubmit}
                                startIcon={<LocalPostOfficeIcon />}
                                disabled={!Boolean(email) || !IsValid.email(email, 100) || resReset.loading}
                            >
                                메일로 암호 재설정 링크 받기
                            </Button>
                            <Button variant='contained' color='inherit'
                                onClick={onClose}
                                startIcon={<UndoIcon />}
                                style={{marginLeft:20}}
                                disabled={resReset.loading}
                            >
                                돌아가기
                            </Button>
                        </Box>
                    </form>
                    {
                        message && <ResponseMessageBox>{message}</ResponseMessageBox>
                    }
                </ContentBody>
            </ContentBox>
        </XContainer>
    );
}



